// src/auth/RequiereAccesoTrabajador.tsx
//
// Guard de ruta para /panel-trabajador: deja pasar solo si el trabajador
// actual tiene acceso (su empresa tiene plan efectivo Y él tiene acceso).
// Bloquea la entrada por URL directa o inicio automático — la tarjeta de
// Profiles ya avisa, pero no impide teclear la ruta a mano.
//
// Sin acceso → vuelve a /profiles, donde ve su tarjeta con "Sin acceso ·
// contacta con tu empresa".
//
// Solo control de UX; la protección real va en RLS.

import { Navigate, Outlet } from 'react-router-dom';
import { useAccesoTrabajador } from '@/components/hooks/useAccesoTrabajador';

export default function RequiereAccesoTrabajador() {
  const { cargando, tieneAcceso } = useAccesoTrabajador();

  if (cargando) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-400" />
      </div>
    );
  }

  if (!tieneAcceso) {
    return <Navigate to="/profiles" replace />;
  }

  return <Outlet />;
}